





































import pusher from '@/lib/pusher';
import { Component, Vue, Prop } from 'vue-property-decorator';
import api_client from '@/lib/api_client';
import confetti from '@/lib/confetti';

interface Game {
  finished_at: Date;
}

@Component
export default class Home extends Vue {
  @Prop(String) public readonly id!: string;

  public game: Game | null = null;

  public async registerScore(roundId: number, playerId: number) {
    const isWon = (this.game as Game).finished_at;
    await api_client.post(`/games/${this.id}/rounds/${roundId}/scores`, {
      player: playerId,
    });
    await this.loadGame();
    if (!isWon && (this.game as Game).finished_at) {
      confetti();
    }
  }

  public async loadGame() {
    this.game = (await api_client.get(`/games/${this.id}`)).data;
  }

  public async mounted() {
    await this.loadGame();
    this.setupWebsocket();
  }

  public get envName() {
    return process.env.VUE_APP_ENV !== undefined
      ? process.env.VUE_APP_ENV
      : 'development';
  }

  public get channelName() {
    return `${this.envName}-${this.id}`;
  }

  public setupWebsocket() {
    const channel = pusher.subscribe(this.channelName);
    channel.bind('update', (data) => {
      this.loadGame();
    });
  }

  public async create() {
    await api_client.post(`/games/${this.id}/rounds`);
    await this.loadGame();
  }
}
